import React from "react";
import { Link } from "react-router-dom";
import { Trophy, Menu, X, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WHATSAPP_SALES_URL } from "@/lib/sales";

const Navbar = () => {
  const [open, setOpen] = React.useState(false);

  const openWhatsApp = () => {
    window.open(WHATSAPP_SALES_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <nav className="navbar fixed top-8 left-0 right-0 z-50" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2" data-testid="logo-link">
            <Trophy className="h-7 w-7 text-green-600" />
            <span className="text-xl font-bold logo-text">FIXEDRAWS</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors" data-testid="nav-home">Home</Link>
            <Link to="/pool/draws" className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors" data-testid="nav-draws">Pool Draws</Link>
            <Link to="/pool/fixtures" className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors" data-testid="nav-fixtures">Fixtures</Link>
            <Link to="/pool/results" className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors" data-testid="nav-results">Pool Results</Link>
            <Link to="/free-games" className="text-gray-600 hover:text-gray-900 text-sm font-medium transition-colors" data-testid="nav-free-games">Free Games</Link>
            <Link to="/referral" className="text-amber-600 hover:text-amber-700 text-sm font-medium transition-colors" data-testid="nav-referral">Refer & Earn</Link>
            <Button onClick={openWhatsApp} className="bg-[#25D366] hover:bg-[#1DAE55] text-white rounded-full px-6" data-testid="nav-buy-btn">
              <MessageCircle className="h-4 w-4 mr-2" /> Buy Games
            </Button>
          </div>

          <button className="md:hidden text-gray-600" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-4 space-y-3">
            <Link to="/" className="block text-gray-600 hover:text-gray-900 py-2 font-medium" onClick={() => setOpen(false)}>Home</Link>
            <Link to="/pool/draws" className="block text-gray-600 hover:text-gray-900 py-2 font-medium" onClick={() => setOpen(false)}>Pool Draws</Link>
            <Link to="/pool/results" className="block text-gray-600 hover:text-gray-900 py-2 font-medium" onClick={() => setOpen(false)}>Pool Results</Link>
            <Link to="/free-games" className="block text-gray-600 hover:text-gray-900 py-2 font-medium" onClick={() => setOpen(false)}>Free Games</Link>
            <Link to="/referral" className="block text-amber-600 hover:text-amber-700 py-2 font-medium" onClick={() => setOpen(false)}>Refer & Earn 30%</Link>
            <Button onClick={() => { openWhatsApp(); setOpen(false); }} className="w-full bg-[#25D366] hover:bg-[#1DAE55] text-white rounded-full">
              <MessageCircle className="h-4 w-4 mr-2" /> Buy Games on WhatsApp
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
